import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckoutAccountComponentDef } from '@df/checkout/checkout-account.component.def';
import { Status } from '@df/core/status';
import { MuiInputDirective } from '@df/legacy/ui/form/mui-input.directive';
import { LoqateEmailValidateDirective } from '@df/module-loqate/email/loqate-email.validator';
import { Newsletter } from '@df/session/newsletter/newsletter.interfaces';
import { NewsletterService } from '@df/session/newsletter/newsletter.service';
import { RadioGroupDirective } from '@df/ui/form/radio/radio.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsConfig } from '@icms/core/resource/config/icms-config';
import { ICmsConfigResource } from '@icms/core/resource/config/icms-config.resource';
import { CMS_CONFIG_NEWSLETTER, IICmsConfigNewsletterDataContent } from '../cms/config/newsletter.cms-config';
import { IfNotTradeStoreDirective } from '../multisite/trade/if-not-trade-store.directive';
import { SocialLoginComponent } from '../ui/3rdparty/social-login.component';
import { ActionComponent } from '../ui/api/action.component';
import { InputWrapBodyDirective } from '../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../ui/form/input-wrap.component';
import { RadioComponent } from '../ui/form/radio';
import { ResultComponent } from '../ui/resut/result.component';
import { CheckoutFormComponent } from './checkout-form.component';
@Component({
    selector: 'checkout-account',
    templateUrl: './checkout-account.html',
    standalone: true,
    imports: [
        ActionComponent,
        FormsModule,
        IfNotTradeStoreDirective,
        InputWrapComponent,
        InputWrapBodyDirective,
        LoqateEmailValidateDirective,
        MuiInputDirective,
        NgClass,
        RadioComponent,
        RadioGroupDirective,
        ResultComponent,
        SocialLoginComponent,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutAccountComponent extends CheckoutAccountComponentDef implements OnInit {
    /**
     * Show only email input
     */
    @Input()
    currentStepName: string;
    isEmailValid: boolean;
    @Input()
    shipping;
    readonly status = new Status();
    protected newsletterPreselection: string | null = null;
    protected subscribeNewsletter = this.timeoutService.throttle(() => this._subscribeNewsletter(), 300);
    protected override emailFieldName = 'email';

    private cmsConfigResource = inject(ICmsConfigResource);
    private newsletter = inject(NewsletterService);

    override ngOnInit() {
        this.cmsConfigResource.loadModelByUrl(CMS_CONFIG_NEWSLETTER).then(() => {
            const config = this.cmsConfigResource.getModelByUrl(CMS_CONFIG_NEWSLETTER) as ICmsConfig<IICmsConfigNewsletterDataContent>;
            const preselection = config?.data?.content?.emailNewsletterPreselection;
            if (preselection === 'all' || preselection === 'checkoutOnly') {
                this.newsletterPreselection = '1';
                (this.checkoutFormComponent.data.newsletter as boolean | string) = '1';
                this.detectChanges();
            }
        });
        super.ngOnInit();
    }
    get isVirtual(): boolean {
        return this.checkoutFormComponent.isVirtual;
    }
    override login(onSuccess?: () => void, onError?: () => void) {
        super.login(onSuccess, onError);
        this.loginStatus.promise.then(() => {
            if (this.isLoggedIn) {
                this.goNextStep();
            }
        });
    }

    goNextStep() {
        this.detectChanges();
        this.timeoutService.setTimeout(() => {
            if (!this.getIsValid()) {
                return;
            }
            this.subscribeNewsletter();
            if (this.currentStepName === 'account') {
                this.checkoutFormComponent.goToNextStep();
            } else {
                this.closeCustomerAccordion();
            }
        });
    }

    closeCustomerAccordion() {
        (this.checkoutFormComponent as CheckoutFormComponent).closeCustomerAccordion();
    }

    continueAsGuestToDelivery() {
        if (this.email && !this.accountRequired) {
            this.setGuestCheckout();
        }
        this.detectChanges();
        this.timeoutService.setTimeout(() => {
            if (!this.getIsValid()) {
                if (!this.form.submitAttempt) {
                    this.form.submitAttempt = true;
                    this.detectChanges();
                }
                return;
            }
            this.subscribeNewsletter();
            if (this.email && !this.accountRequired) {
                this.timeoutService.setTimeout(() => {
                    this.checkoutFormComponent.goToNextStep();
                }, 100);
            }
        });
    }
    override shouldRegister(): boolean {
        return !this.isLoggedIn && this.isChecked() && !this.hasAccount();
    }
    onLoginSuccess = () => {
        this.timeoutService.setTimeout(() => {
            this.checkoutFormComponent.goToNextStep();
        }, 100);
    };

    protected override onLogoutSuccess(): void {
        if (this.data) {
            this.data.password = undefined;
        }
        this.email = undefined;
        this.detectChanges();
    }
    private _subscribeNewsletter(): void {
        if ((this.checkoutFormComponent.data.newsletter as boolean | string) === '1') {
            const data = <Newsletter.ISubscriptionFormData>{ source: this.source, ...this.data };
            this.newsletter.subscribe(
                this.form,
                this.status,
                data,
                () => {},
                () => {}
            );
        }
    }
}
